import { decodeFriendFamily } from './services'

const getDefaultState = () => {
  return {
    displayPricing: false,
    isFriendFamily: false,
    bookingNumber: null,
    bookingName: null
  }
}

const state = getDefaultState()
const getters = {
  isFriendFamily: (state) => {
    return state.isFriendFamily
  },
  displayPricing: (state) => {
    return state.displayPricing
  }
}
const actions = {
  async decodeUNID  ({ dispatch, commit }, unid) {
    dispatch('spinner/updateLoadingAction', true, { root: true })
    const result = await decodeFriendFamily(unid)
    dispatch('spinner/updateLoadingAction', false, { root: true })

    if (result.data) {
      commit('decodedData', result.data)
    }
  }
}

const mutations = {
  decodedData (state, data) {
    state.isFriendFamily = true
    state.bookingNumber = data.bookno
    state.bookingName = data.surname
    if (data.cost === 'true') {
      state.displayPricing = true
    }
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
